/* wd-boost.js — 2026-08-20
   Quattro interventi indipendenti, ognuno con la sua guardia:
   1) prefetch al passaggio del mouse    -> navigazione percepita più rapida
   2) filtro prezzo a cursore            -> niente più cifre da digitare
   3) conferma esplicita della taglia    -> niente acquisti sulla taglia di default
   4) opzioni a valore unico compattate  -> prezzo e taglie risalgono sopra la piega
   Nessuno dei quattro tocca il form di Shopify: la variante resta quella
   calcolata dal tema. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ================================================================
     1. Prefetch al passaggio del mouse / primo tocco
     Il catalogo si naviga per liste lunghe: precaricare la pagina che
     il cliente sta per aprire toglie l'attesa quasi per intero.
     ================================================================ */
  /* ----------------------------------------------------------------
     Stringhe dell'interfaccia.
     Erano scritte in italiano nel codice, quindi restavano in italiano
     anche su /en/ e /es/ — dove arriva il 59% degli ordini online.
     document.documentElement.lang lo imposta il tema da request.locale.
     ---------------------------------------------------------------- */
  var LANG = (document.documentElement.lang || 'it').slice(0, 2).toLowerCase();
  var DICT = {
    it: { from: 'Da ', upto: 'Fino a ', sizeHint: 'Scegli la tua taglia per continuare.', more: 'Titolo completo', less: 'Riduci', rangeHint: 'Trascina per restringere la fascia di prezzo.', priceMin: 'Prezzo minimo', priceMax: 'Prezzo massimo' },
    en: { from: 'From ', upto: 'Up to ', sizeHint: 'Choose your size to continue.', more: 'Full title', less: 'Show less', rangeHint: 'Drag to narrow the price range.', priceMin: 'Minimum price', priceMax: 'Maximum price' },
    es: { from: 'Desde ', upto: 'Hasta ', sizeHint: 'Elige tu talla para continuar.', more: 'T\u00edtulo completo', less: 'Mostrar menos', rangeHint: 'Arrastra para acotar el rango de precios.', priceMin: 'Precio m\u00ednimo', priceMax: 'Precio m\u00e1ximo' },
    fr: { from: 'D\u00e8s ', upto: 'Jusqu\u2019\u00e0 ', sizeHint: 'Choisissez votre taille pour continuer.', more: 'Titre complet', less: 'Voir moins', rangeHint: 'Faites glisser pour affiner la fourchette de prix.', priceMin: 'Prix minimum', priceMax: 'Prix maximum' },
    de: { from: 'Ab ', upto: 'Bis ', sizeHint: 'W\u00e4hle deine Gr\u00f6\u00dfe, um fortzufahren.', more: 'Ganzer Titel', less: 'Weniger anzeigen', rangeHint: 'Ziehen, um die Preisspanne einzugrenzen.', priceMin: 'Mindestpreis', priceMax: 'H\u00f6chstpreis' }
  };
  var T = DICT[LANG] || DICT.it;

  (function prefetchOnIntent() {
    var conn = navigator.connection;
    if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;
    if (!document.createElement('link').relList.supports('prefetch')) return;

    var done = Object.create(null);
    var budget = 10;

    function eligible(a) {
      if (!a || !a.href || a.target === '_blank' || a.hasAttribute('download')) return false;
      var url;
      try { url = new URL(a.href); } catch (e) { return false; }
      if (url.origin !== location.origin) return false;
      if (url.pathname === location.pathname) return false;
      if (!/^\/(products|collections|pages|blogs)\//.test(url.pathname)) return false;
      // Il carrello e le azioni non si precaricano: cambiano stato.
      if (/\/cart|\/checkout|\/account/.test(url.pathname)) return false;
      return true;
    }

    function prefetch(href) {
      if (done[href] || budget <= 0) return;
      done[href] = true;
      budget--;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      link.as = 'document';
      document.head.appendChild(link);
    }

    var timer = null;

    function onIntent(event) {
      var a = event.target.closest ? event.target.closest('a[href]') : null;
      if (!eligible(a)) return;
      clearTimeout(timer);
      // 65ms di attesa: evita di precaricare tutto ciò che si sfiora scorrendo.
      timer = setTimeout(function () { prefetch(a.href); }, 65);
    }

    document.addEventListener('mouseover', onIntent, { passive: true });
    document.addEventListener('focusin', onIntent, { passive: true });
    document.addEventListener('touchstart', onIntent, { passive: true });
    document.addEventListener('mouseout', function () { clearTimeout(timer); }, { passive: true });
  })();

  /* ================================================================
     2. Filtro prezzo a cursore
     Dawn chiede due importi scritti a mano. Qui restano nel form per
     l'invio, ma il cliente trascina due maniglie.
     ================================================================ */
  function currency(value) {
    try {
      return new Intl.NumberFormat('it-IT', {
        style: 'currency', currency: 'EUR', maximumFractionDigits: 0
      }).format(value);
    } catch (e) {
      return '€' + Math.round(value);
    }
  }

  function buildRange(host) {
    if (host.dataset.wdRange === 'on') return;

    var gte = host.querySelector('input[name="filter.v.price.gte"]');
    var lte = host.querySelector('input[name="filter.v.price.lte"]');
    if (!gte || !lte) return;

    var realMax = Math.ceil(parseFloat(lte.dataset.max || gte.dataset.max || '0'));
    if (!realMax || realMax <= 0) return;

    host.dataset.wdRange = 'on';

    // Passo leggibile: 5 € sotto i 500, 10 € sopra.
    var step = realMax > 500 ? 10 : 5;
    // Il massimo va arrotondato al passo, altrimenti la maniglia destra si
    // ferma sotto il prezzo più alto del catalogo (304 € diventava 300 €).
    var max = Math.ceil(realMax / step) * step;

    var startMin = Math.max(0, Math.floor(parseFloat(gte.value || '0')) || 0);
    var startMax = Math.min(max, Math.ceil(parseFloat(lte.value || '') || max));

    var wrap = document.createElement('div');
    wrap.className = 'wd-range';
    wrap.innerHTML =
      '<div class="wd-range__readout"><span data-lo></span><span data-hi></span></div>' +
      '<div class="wd-range__track">' +
      '<span class="wd-range__rail"></span><span class="wd-range__fill"></span>' +
      '<input type="range" data-min-input aria-label="' + T.priceMin + '">' +
      '<input type="range" data-max-input aria-label="' + T.priceMax + '">' +
      '</div>' +
      '<p class="wd-range__hint">' + T.rangeHint + '</p>';

    var lo = wrap.querySelector('[data-min-input]');
    var hi = wrap.querySelector('[data-max-input]');
    var loOut = wrap.querySelector('[data-lo]');
    var hiOut = wrap.querySelector('[data-hi]');
    var fill = wrap.querySelector('.wd-range__fill');

    [lo, hi].forEach(function (input) {
      input.min = 0;
      input.max = max;
      input.step = step;
    });
    lo.value = startMin;
    hi.value = startMax;

    function paint() {
      var a = Math.min(+lo.value, +hi.value);
      var b = Math.max(+lo.value, +hi.value);
      loOut.textContent = T.from + currency(a);
      hiOut.textContent = T.upto + currency(b >= max ? realMax : b);
      fill.style.left = (a / max) * 100 + '%';
      fill.style.right = 100 - (b / max) * 100 + '%';
    }

    // Le due maniglie non si scavalcano.
    function clamp(moved) {
      if (+lo.value > +hi.value) {
        if (moved === lo) lo.value = hi.value;
        else hi.value = lo.value;
      }
      paint();
    }

    lo.addEventListener('input', function () { clamp(lo); });
    hi.addEventListener('input', function () { clamp(hi); });

    function commit() {
      var a = Math.min(+lo.value, +hi.value);
      var b = Math.max(+lo.value, +hi.value);
      gte.value = a > 0 ? String(a) : '';
      lte.value = b < max ? String(b) : '';

      // Prima si prova la strada del tema (aggiornamento senza ricaricare).
      [gte, lte].forEach(function (input) {
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      // Se dopo un attimo l'URL non riflette il filtro, si naviga a mano:
      // meglio un ricaricamento che un cursore che non filtra.
      var expected = gte.value;
      setTimeout(function () {
        var params = new URLSearchParams(location.search);
        if ((params.get('filter.v.price.gte') || '') === expected) return;
        var next = new URLSearchParams(location.search);
        next.delete('filter.v.price.gte');
        next.delete('filter.v.price.lte');
        next.delete('page');
        if (gte.value) next.set('filter.v.price.gte', gte.value);
        if (lte.value) next.set('filter.v.price.lte', lte.value);
        var qs = next.toString();
        location.assign(location.pathname + (qs ? '?' + qs : ''));
      }, 1400);
    }

    lo.addEventListener('change', commit);
    hi.addEventListener('change', commit);

    paint();
    host.parentNode.insertBefore(wrap, host);
    host.classList.add('wd-range-replaced');
  }

  function initRanges(root) {
    (root || document).querySelectorAll('price-range').forEach(buildRange);
  }

  /* ================================================================
     3. Scheda prodotto: taglia da confermare, opzioni finte compattate
     ================================================================ */
  // Nomi dell'opzione taglia, anche tradotti: su /es/ Shopify rende "Tamaño"
  // e su /en/ "Size". Con il solo elenco italiano il riconoscimento falliva in
  // spagnolo, quindi il blocco taglia non si attivava e si poteva aggiungere al
  // carrello la variante predefinita senza sceglierla. "tama" evita la enne
  // con tilde, "numer" copre l'opzione "Numero" usata da parte del catalogo.
  var SIZE_RE = /taglia|size|misura|talla|tama|numer/i;

  function fieldLabel(field) {
    var el = field.querySelector('legend, .form__label');
    return el ? el.textContent : '';
  }

  function initProduct() {
    var main = document.getElementById('MainContent');
    if (!main || (document.querySelector('main[data-template]') || {}).dataset === undefined) return;
    if ((document.querySelector('main[data-template]').dataset.template || '') !== 'product') return;

    var fields = main.querySelectorAll('.product-form__input');
    var sizeField = null;

    fields.forEach(function (field) {
      var radios = field.querySelectorAll('input[type="radio"]');
      var select = field.querySelector('select');
      var count = select ? select.options.length : radios.length;

      // Una sola scelta possibile non è una scelta: è una specifica.
      if (count === 1) {
        field.classList.add('wd-single-option');
        return;
      }
      if (!sizeField && SIZE_RE.test(fieldLabel(field))) sizeField = field;
    });

    if (!sizeField) return;

    var form = main.querySelector('product-form, .product-form');
    var addButton = form ? form.querySelector('button[name="add"]') : null;
    if (!addButton) return;

    // Prodotto esaurito in tutte le taglie: non c'è nulla da scegliere, e il
    // messaggio «Scegli la tua taglia per continuare» sopra otto taglie barrate
    // contraddice quello che il cliente vede. Dawn lascia abilitata la sola
    // taglia selezionata anche se esaurita (deve restare checked), quindi il
    // segnale è: nessun'altra taglia abilitata E pulsante già «Esaurito».
    if (addButton.disabled && sizeField.querySelector('input[type="radio"]') && !sizeField.querySelector('input[type="radio"]:not(:disabled):not(:checked)')) return;

    // Se si arriva con una variante già scelta (link condiviso, ritorno dal
    // carrello) la scelta è del cliente e non va rimessa in discussione.
    if (new URLSearchParams(location.search).has('variant')) return;

    var confirmed = false;

    // 2026-09-28: Dawn SOSTITUISCE i fieldset delle opzioni a ogni cambio di
    // variante. Prima i listener stavano sul fieldset della taglia: chi
    // sceglieva prima Fondo o Tacco e poi la taglia restava bloccato, perche'
    // il fieldset nuovo non aveva il listener e il pulsante restava
    // intercettato («Aggiungi al carrello» non faceva nulla fino al ricarico).
    // Ora tutto e' delegato al documento e il fieldset si ricerca ogni volta.
    function currentSizeField() {
      var list = main.querySelectorAll('.product-form__input');
      for (var i = 0; i < list.length; i++) {
        if (SIZE_RE.test(fieldLabel(list[i])) && !list[i].classList.contains('wd-single-option')) return list[i];
      }
      return null;
    }
    function isSizeTarget(target) {
      var f = target && target.closest ? target.closest('.product-form__input') : null;
      return !!(f && main.contains(f) && SIZE_RE.test(fieldLabel(f)));
    }

    var hint = document.createElement('span');
    hint.className = 'wd-size-hint';
    hint.textContent = T.sizeHint;

    function mark() {
      if (confirmed) return;
      var f = currentSizeField();
      if (!f) return;
      f.classList.add('wd-awaiting-size');
      if (hint.parentNode !== f) f.appendChild(hint);
      var btn = main.querySelector('button[name="add"]') || addButton;
      btn.classList.add('wd-awaiting-size');
      main.querySelectorAll('.shopify-payment-button').forEach(function (el) { el.classList.add('wd-awaiting-size'); });
    }
    mark();

    function release() {
      if (confirmed) return;
      confirmed = true;
      document.querySelectorAll('.wd-awaiting-size').forEach(function (el) { el.classList.remove('wd-awaiting-size'); });
      if (hint.parentNode) hint.parentNode.removeChild(hint);
      if (observer) observer.disconnect();
      // La barra d'acquisto sticky (wd-sticky-buy) ascolta questo evento: senza,
      // toccando la taglia gia' preselezionata (click senza change) restava su
      // «Scegli taglia».
      document.dispatchEvent(new CustomEvent('wd:size-confirmed'));
    }

    // 2026-09-29: la taglia BARRATA (input disabled o .disabled) non conferma
    // nulla: il tocco apre la richiesta taglia e la selezione resta quella
    // preimpostata da Dawn, che il cliente non ha scelto.
    function sizeInput(target) {
      if (!target || !target.closest) return null;
      if (target.matches && target.matches('input')) return target;
      var label = target.closest('label');
      if (label && label.htmlFor) return document.getElementById(label.htmlFor);
      return label ? label.querySelector('input') : null;
    }
    function barrata(input) {
      return !!(input && (input.disabled || input.classList.contains('disabled')));
    }

    document.addEventListener('change', function (event) {
      if (isSizeTarget(event.target) && !barrata(sizeInput(event.target))) release();
    }, true);
    document.addEventListener('click', function (event) {
      if (!isSizeTarget(event.target) || !event.target.closest('label, input, option')) return;
      if (event.target.closest('option') || !barrata(sizeInput(event.target))) release();
    }, true);
    // Da tastiera: Spazio o Invio su un radio gia' selezionato non emettono ne'
    // click ne' change, quindi la taglia preselezionata non si poteva confermare.
    document.addEventListener('keydown', function (event) {
      if (event.key !== ' ' && event.key !== 'Enter') return;
      if (isSizeTarget(event.target) && !barrata(sizeInput(event.target))) release();
    }, true);

    // Dopo un ridisegno di Dawn (cambio di Fondo/Tacco prima della taglia) il
    // fieldset nuovo non ha la classe ne' il suggerimento: si rimettono.
    var observer = null;
    var pending = null;
    if (window.MutationObserver) {
      observer = new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(mark, 60);
      });
      observer.observe(main, { childList: true, subtree: true });
    }

    // Intercettare il click invece di disabilitare il pulsante: il tema
    // gestisce già `disabled` per le varianti esaurite e non va scavalcato.
    // Delegato anche questo: se Dawn rimpiazza il pulsante, il blocco segue.
    document.addEventListener(
      'click',
      function (event) {
        if (confirmed) return;
        // Anche il pagamento rapido («Acquista con Shop», Apple/Google Pay):
        // prima scavalcava il blocco e comprava la taglia preselezionata.
        var btn = event.target.closest ? event.target.closest('button[name="add"], .shopify-payment-button, shopify-accelerated-checkout, shop-pay-wallet-button') : null;
        if (!btn || !main.contains(btn)) return;
        event.preventDefault();
        event.stopPropagation();
        var f = currentSizeField();
        if (!f) return;
        f.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'center'
        });
        f.classList.remove('wd-flash');
        void f.offsetWidth;
        f.classList.add('wd-flash');
      },
      true
    );
  }

  /* ================================================================
     4. Titolo prodotto espandibile
     Il titolo è tagliato a 3 righe per far risalire prezzo e taglie;
     chi vuole la denominazione completa la apre.
     ================================================================ */
  function initTitle() {
    var box = document.querySelector('.product__title');
    if (!box) return;
    var heading = box.querySelector('h1, .h1');
    if (!heading || heading.scrollHeight <= heading.clientHeight + 2) return;

    var more = document.createElement('button');
    more.type = 'button';
    more.className = 'wd-title-more';
    more.textContent = T.more;
    more.addEventListener('click', function () {
      var open = box.classList.toggle('wd-title-open');
      more.textContent = open ? T.less : T.more;
    });
    box.appendChild(more);
  }

  function boot() {
    initRanges(document);
    initProduct();
    initTitle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // I facet vengono ridisegnati via AJAX a ogni filtro: il cursore va rimesso.
  document.addEventListener('shopify:section:load', function () { initRanges(document); });
  var reinit = null;
  new MutationObserver(function () {
    clearTimeout(reinit);
    reinit = setTimeout(function () { initRanges(document); }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
